const results = [
  { icon: 'ri-speed-up-line', title: 'Быстрее адаптация', desc: 'Новички выходят на KPI в 1,5-2 раза быстрее благодаря чек-листам, наставничеству и структурированной программе онбординга.' },
  { icon: 'ri-user-heart-line', title: 'Ниже текучесть', desc: 'Снижение текучести на 30-50% в первые 6 месяцев. Сотрудники видят перспективы развития и не уходят к конкурентам.' },
  { icon: 'ri-line-chart-line', title: 'Рост продаж', desc: 'Повышение конверсии и среднего чека после внедрения академии продаж. Единые скрипты,標準ы и постоянная практика.' },
  { icon: 'ri-emotion-happy-line', title: 'Выше вовлечённость', desc: 'Рост eNPS на 15-25 пунктов. Когда компания инвестирует в развитие, сотрудники отвечают лояльностью.' },
  { icon: 'ri-file-copy-line', title: 'Единые стандарты', desc: 'Все работают по единым регламентам. Качество предсказуемо и не зависит от конкретного сотрудника.' },
  { icon: 'ri-close-circle-line', title: 'Меньше ошибок', desc: 'Снижение операционных ошибок на 40-60%. Стандарты и регулярное обучение исключают «человеческий фактор».' },
  { icon: 'ri-share-forward-line', title: 'Передача знаний', desc: 'Опыт лучших сотрудников зафиксирован в базе знаний. При уходе ключевого сотрудника знания остаются в компании.' },
  { icon: 'ri-rocket-2-line', title: 'Быстрее масштабирование', desc: 'Открытие новых филиалов и направлений без потери качества. Академия тиражирует стандарты на новые точки.' },
  { icon: 'ri-trophy-line', title: 'Рост производительности', desc: 'Повышение производительности труда на 20-35% за счёт системного развития компетенций и внедрения лучших практик.' },
];

export default function BusinessResults() {
  return (
    <section id="results" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Какие результаты получает бизнес
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Корпоративная академия — это не расходы, а инвестиция с измеримым возвратом. Вот что получают компании после внедрения системы обучения.
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {results.map((r, i) => (
            <div key={i} className="bg-white rounded-xl p-6 border border-gray-200 hover:border-teal-300 hover:shadow-md transition-all text-center group">
              <div className="w-14 h-14 bg-teal-600 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
                <i className={`${r.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-2 text-base">{r.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}